import React, { useEffect, useRef } from 'react';

const CipherBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Set canvas size
    const resizeCanvas = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    };
    
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();

    // Configuration
    const fontSize = 14;
    const columns = Math.floor(canvas.width / fontSize);
    const drops = new Array(columns).fill(1);
    
    // characters to rain down (Hex + Env Vars)
    const chars = "01ABCDEFXYZ$_!".split("");

    const draw = () => {
      // Semi-transparent black to create "trail" effect
      ctx.fillStyle = 'rgba(5, 5, 5, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = `${fontSize}px monospace`;

      for (let i = 0; i < drops.length; i++) {
        // Randomize character
        const text = chars[Math.floor(Math.random() * chars.length)];
        
        // Logic: 
        // 1% chance to be Orange (The "Secret"), otherwise Dark Gray (The "Noise")
        const isHighlight = Math.random() > 0.98;
        ctx.fillStyle = isHighlight ? '#f97316' : '#262626'; // Orange-500 vs Neutral-800

        ctx.fillText(text, i * fontSize, drops[i] * fontSize);

        // Reset drop to top randomly
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }

        // Move drop down
        drops[i]++;
      }
    };

    const interval = setInterval(draw, 33); // ~30FPS

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <canvas 
        ref={canvasRef} 
        className="absolute inset-0 w-full h-full opacity-60 pointer-events-none"
    />
  );
};

export default CipherBackground;